import { InfiniteItemRenderer, InfiniteScrollList } from "@/components/common/scroll";
import { LIMIT } from "@/constants";
import { currencyFormatter } from "@/utils";
import { dateFormateDDMMYYYY, getStatusColors } from "@/utils/common";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import "./PurchasedProduct.css";
import { useGetOrderListQuery } from "@/features/order";
import { Button } from "@/components/ui/button";
import { Order } from "@/interfaces/order";
import { OrderStateEnum } from "@/enum";

export const Route = createFileRoute("/(app)/(store)/expense/purchase/")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const limit = LIMIT * 3;
  const [page, setPage] = useState(1);
  const {
    data = [],
  } = useGetOrderListQuery({
    ["order-type"]: "BuyOrder",
    page,
    limit: LIMIT * 2,
  });
  const renderPurchasedItem:InfiniteItemRenderer<Order> = (item) => {
    const { statusColor, bgColor } = getStatusColors(
      item.status !== OrderStateEnum.Cancelled ? item?.payment?.paymentStatus as any :  item.status
    );
    const visibleProducts = item.itemList?.slice(0, 2) || [];
    const remainingProductsCount = Math.max(
      (item.itemList?.length || 0) - 2,
      0
    );
    return (
      <div
        className="orderItem"
        key={item._id}
        onClick={() =>
          navigate({
            to: "/sales/$orderId",
            params: { orderId: item._id },
          })
        }
      >
        <div className="orderItemGradient">
          <div className="orderItemHeader">
            <div className="orderInfo">
              <p className="billTotal">
                Bill Total:{" "}
                <span className="billAmount">
                  {currencyFormatter(item.totalAmount)}
                </span>
              </p>
              <text className="caption">{item?.sellerStore?.name}</text>
              <text className="tag">#{item?.invoiceNumber}</text>
            </div>

            <div className="statusBadge" style={{ backgroundColor: bgColor }}>
              <span style={{ color: statusColor }}>
                {item.payment?.paymentStatus}
              </span>
            </div>
          </div>
        </div>

        <div className="orderItemContent">
          {visibleProducts.length > 0 ? (
            <>
              <div className="productsColumn">
                {visibleProducts.map((productItem, index) => (
                  <div key={index} className="productRow">
                    {productItem.product?.image && (
                      <img
                        className="productImage"
                        src={productItem.product.image}
                      />
                    )}
                    <text className="quantityText body">
                      {productItem.unitWiseQuantity?.quantity || 0}
                    </text>
                    <text className="productName body">
                      {" X "+ productItem.product?.name || "Product not specified"}
                    </text>
                  </div>
                ))}
              </div>

              {remainingProductsCount > 0 && (
                <div className="remainingProducts">
                  <text className="caption">
                    +{remainingProductsCount} more item
                    {remainingProductsCount !== 1 ? "s" : ""}
                  </text>
                </div>
              )}
            </>
          ) : (
            <div className="noProductsContainer">
              <text className="noProductsText">No products in this order</text>
            </div>
          )}

          <div className="statusRow">
            <text className="caption">
              {item.payment?.paymentStatus === "Paid" ? "Paid on" : "Due on"}{" "}
              {dateFormateDDMMYYYY(item.createdAt)}
            </text>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="orderList">
      <div className="createOrderContainer">
        <Button  to="/expense/purchase/create">
          Purchase Order
        </Button>
      </div>
      <InfiniteScrollList
        renderItem={renderPurchasedItem}
        items={data}
        loadMore={() => setPage((pre) => pre + 1)}
        hasMore={limit * page <= data?.length}
        maxHeight={"90dvh"}
      />
    </div>
  );
}
